import { UseGetLineReturn } from "./useGetLine.decl";

import {
  GetLineQuery,
  GetLineQueryVariables,
} from "@/graphql/generated/graphql";
import { GetLine } from "@/graphql/queries/GetLine";
import { useQueryWrapper } from "@/hooks/useQueryWrapper/useQueryWrapper";
import { usePathParams } from "@/states/path_param";
import { useGetLineId } from "../useGetLineId/useGetLineId";

export function useGetLine(): UseGetLineReturn {
  const { callId } = usePathParams();
  const { lineId } = useGetLineId({ callId });
  const { data, loading } = useQueryWrapper<
    GetLineQuery,
    GetLineQueryVariables
  >(GetLine, {
    skip: !lineId,
    variables: {
      filter: {
        ID: {
          eq: lineId,
        },
      },
    },
  });

  return {
    lineId,
    line: data?.searchAuthorizedLines?.items?.[0],
    loading,
  };
}
